module.exports = __webpack_public_path__ + "dfeb647127285a97947eda973e46becc.svg";